/**
 * @generated SignedSource<<e2cf86544c0fd41b97f82921e87723cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationForm_brand$data = {
  readonly deeplinkUrlScheme: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"CDPAudienceSelectorCard_brand">;
  readonly " $fragmentType": "NotificationForm_brand";
};
export type NotificationForm_brand$key = {
  readonly " $data"?: NotificationForm_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationForm_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationForm_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deeplinkUrlScheme",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CDPAudienceSelectorCard_brand"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "7b4b742308618bd499694dad8c14999b";

export default node;
